import { render, staticRenderFns } from "./CornerRightTop.vue?vue&type=template&id=0a272254&scoped=true&"
import script from "./CornerRightTop.vue?vue&type=script&lang=js&"
export * from "./CornerRightTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a272254",
  null
  
)

export default component.exports